export type Role = 'master' | 'support' | 'moderator' | 'admin';

export function hasRole(userRoles: Role[], targetRole: Role) {
  const rolesToSearch = [targetRole];
  // admin role extends support and moderator roles
  if (['support', 'moderator'].includes(targetRole))
    rolesToSearch.push('admin');
  return userRoles.some((role) => rolesToSearch.includes(role));
}
